import { Injectable } from '@angular/core';
import { HttpService } from '../providers/http.service';
import { AppConfig } from '../app/app.config';

@Injectable()
export class PasswordService {

    constructor(
        private httpService: HttpService) { }
    
    //修改登录密码
    //chen 2017-03-13
    getReviseLogin(param){
        var url = AppConfig.GetProdUrl()+ "/User/Pwd";
        return this.httpService.post(url,param);
    }

    //修改资金密码
    //chen 2017-03-13
    getReviseMoney(param){
        var url = AppConfig.GetProdUrl()+ "/User/Funds";
        return this.httpService.post(url,param);
    }

    //创建资金密码
    //chen 2017-03-13
    getCreateMoney(param){
        var url = AppConfig.GetProdUrl()+ "/User/CreateBankPassword";
        return this.httpService.post(url,param);
    }

    //验证是否设置资金密码
    //chen 2017-03-14
    getCheckCreateMoney(){
        var url = AppConfig.GetProdUrl()+ "/User/CheckBankPassword";
        return this.httpService.post(url,"");
    }



}


// WEBPACK FOOTER //
// ./src/services/password.service.ts